import { render, staticRenderFns } from "./SubsidiesSettings.vue?vue&type=template&id=7a02a70d"
import script from "./SubsidiesSettings.vue?vue&type=script&lang=ts"
export * from "./SubsidiesSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports